import { render, staticRenderFns } from "./CardTransferSwap.vue?vue&type=template&id=3067ad1c&scoped=true"
import script from "./CardTransferSwap.js?vue&type=script&lang=js&external"
export * from "./CardTransferSwap.js?vue&type=script&lang=js&external"
import style0 from "./CardTransferSwap.vue?vue&type=style&index=0&id=3067ad1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067ad1c",
  null
  
)

export default component.exports